import api from "@/lib/api";

export const getMemberCard = async (memberId: string) => {
  return api.get(`/cards/${memberId}`);
};

export const getReferralData = async (referralCode: string) => {
  return api.get(`/registrations/${referralCode}`);
};

export const registerMember = async (referral_code: string, data: any) => {
  return api.post("/registrations?referral_code=" + referral_code, data);
};

export const getMaritalStatuses = async () => {
  return api.get("/members/marital-statuses");
};

export const getReligions = async () => {
  return api.get("/members/religions");
};

export const getEmploymentStatuses = async () => {
  return api.get("/members/employment-statuses");
};
